<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      门店管理
      <small>
        /&nbsp;
        <router-link to="/storelist" class="TitleStyle">门店列表</router-link>/&nbsp;店员列表
      </small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">店员列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <div class="col-md-8"></div>

                      <div class="col-md-3"></div>
                      <div class="col-md-1" v-if="!roleList.map(item => item.roleId).includes(5101)">
                        <a
                          class="btn btn-primary ButtonColor"
                          @click="AddClick()"
                          style="float:right;"
                        >新增</a>
                      </div>
                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>
                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="shooperName" label="姓名" align="center"></el-table-column>
                  <el-table-column prop="shooperTel" label="联系方式" align="center"></el-table-column>
                  <el-table-column prop="shoperrole" label="职位" align="center"></el-table-column>

                  <el-table-column label="操作" width="280" align="center">
                    <template slot-scope="scope">
                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="DetailClick(scope.row)"
                      >详情</a>
                      <a class="btn btn-primary btn-sm ButtonColor" v-if="!roleList.map(item => item.roleId).includes(5101)" @click="EditClick(scope.row)">编辑</a>
                      <a
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="DeleteClick(scope.row)"
                        v-if="(scope.row.shoperRole !== 3 && is_HongKongCheck == false) && !roleList.map(item => item.roleId).includes(5101)"
                      >删除</a>
                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="CodeClick(scope.row)"
                      >生成二维码</a>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="height:46px;padding-top:16px;">
                  <a
                    class="btn btn-primary m-r-5"
                    style="float:right;cursor:pointer;color:#fff !important"
                    @click="Goback"
                  >返&nbsp;&nbsp;回</a>

                  <span class="clear"></span>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisibles" width="400px" :before-close="handleClose">
      <div class="ModelPaddings">
        <img id="scream" :src="imgurl" alt="" width='250' height='250' style="display:none;">
        <canvas id="myCanvas" width="300" height="330"></canvas>
        <qrcode style="display:none;" :url="qrcodeParams.url" :iconurl="qrcodeParams.icon" :wid="qrcodeParams.width" :hei="qrcodeParams.height" :imgwid="qrcodeParams.imgwidth" :imghei="qrcodeParams.imgheight" :colorDark="qrcodeParams.colorDark" :colorLight="qrcodeParams.colorLight"></qrcode>
      </div>
    </el-dialog>
    <el-dialog title :visible.sync="outerVisible" :width="OuterWidth">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定删除吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSure"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :inline="true"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-form-inline"
        >
          <el-form-item label="员工名称:" prop="shooperName">
            <el-input
              v-model="ruleForm.shooperName"
              :disabled="DialogTitle === '编辑' && ruleForm.shoperRole === 3"
              placeholder="员工名称"
              class="DistributorMargin InputWidth"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系方式:" prop="shooperTel">
            <el-input
              v-model="ruleForm.shooperTel"
              :disabled="(DialogTitle === '编辑' && ruleForm.shoperRole === 3) || is_HongKong"
              placeholder="联系方式"
              class="DistributorMargin InputWidth"
            ></el-input>
          </el-form-item>
          <el-form-item label="职位:" prop="shoperRole">
            <el-select
              :disabled="DialogTitle === '编辑' && ruleForm.shoperRole === 3"
              v-model="ruleForm.shoperRole"
              clearable
              placeholder="请选择"
              class="DistributorMargin InputWidth"
            >
              <el-option
                v-for="item in RoleList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="账户名称:" prop="trueName">
            <el-input
              v-model="ruleForm.trueName"
              placeholder="账户名称"
              class="DistributorMargin InputWidth"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行卡号:" prop="bankCard">
            <el-input
              v-model="ruleForm.bankCard"
              placeholder="银行卡号"
              class="DistributorMargin InputWidth"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户银行:" prop="bankName" class="labelstyle">
            <el-select
              filterable
              clearable
              v-model="ruleForm.bankName"
              placeholder="请选择"
              class="DistributorMargin InputWidth"
            >
              <el-option
                v-for="item in bankList"
                :key="item.bankCode"
                :label="item.bankName"
                :value="item.bankCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行所在省:" prop="bankProvince">
            <el-select
              v-model="ruleForm.bankProvince"
              clearable
              placeholder="请选择"
              class="DistributorMargin InputWidth"
              @change="bankChange"
            >
              <el-option
                v-for="item in ProvincesList"
                :key="item.provinceName"
                :label="item.provinceName"
                :value="item.provinceName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行所在市:" prop="bankCity">
            <el-select
              v-model="ruleForm.bankCity"
              clearable
              placeholder="请选择"
              class="DistributorMargin InputWidth"
            >
              <el-option
                v-for="item in cityList"
                :key="item.cityName"
                :label="item.cityName"
                :value="item.cityName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户支行:" prop="bankBranchName">
            <el-input
              v-model="ruleForm.bankBranchName"
              placeholder="开户支行"
              class="DistributorMargin InputWidth"
            ></el-input>
          </el-form-item>
          <el-form-item label="持卡人身份证号:" prop="idCard">
            <el-input
              v-model="ruleForm.idCard"
              placeholder="持卡人身份证号"
              class="DistributorMargin InputWidth"
            ></el-input>
          </el-form-item>
          <el-form-item label="持卡人手机号:" prop="bankTel" style="float:left;padding-left:16px">
            <el-input
              v-model="ruleForm.bankTel"
              placeholder="持卡人手机号"
              class="DistributorMargin InputWidth"
            ></el-input>
            <p style="padding-left: 16px; color: #F56C6C;margin-bottom: 0;">（短信提醒）</p>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import QRCode from "qrcode";
import qrcode from 'vue_qrcodes';

export default {
  name: "SelesClerkList",
  components:{
    qrcode
  },
  data() {
    var checktel = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkidCard = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的身份证号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("门店名称必须小于33位"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkidtel = (rule, value, callback) => {
      setTimeout(() => {
        let reg =  /^1[3456789]\d{9}$/;
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkbankCard = (rule, value, callback) => {
      setTimeout(() => {
        let reg =  /^\d{8,}$/;
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的银行卡号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkbankidCard = (rule, value, callback) => {
      setTimeout(() => {
        let reg =  /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的身份证号"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      outerVisibles: false,
      disabled: false,
      DialogTitle: "编辑",
      EditDialog: 1,
      OuterWidth: "500px",
      CurrentSelection: [],
      pageNo: 1,
      MarginLeft: 0,
      pageSize: 10,
      options: [],
      bankList: [],
      shopId: "",
      recomId:'',
      RoleList: [{ value: 1, label: "员工" }, { value: 2, label: "店长" }],
      ProvincesList: [],
      TypeList: [{ value: "P", label: "一类户" }],
      ruleForm: {},
      rules: {
        shooperName: [
          { required: true, message: "请输入员工名称", trigger: "blur" },
          { validator: checkName, trigger: "blur" }
        ],
        shooperTel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: checktel, trigger: "blur" }
        ],
        shoperRole: [
          { required: true, message: "请输入职位", trigger: "blur" }
        ],
        bankCard: [
          { required: false, validator: checkbankCard, trigger: "blur" }
        ],
        idCard: [
          { required: false, validator: checkbankidCard, trigger: "blur" }
        ],
        bankTel: [
          { required: false, validator: checkidtel, trigger: "blur" }
        ]
      },
      cityList: [],
      UserManagementList: [],
      recom_id:'',
      qrcodeParams:{
        url: '',
        icon: require('../../assets/quanqiugou.png'),
        width: 250,
        height: 250,
        imgwidth: 50,
        imgheight: 50,
        colorDark: '#003C81',
        colorLight: '#ffffff'
      },
      imgurl:'',
      is_HongKong:false,
      is_HongKongCheck:false,
      isAll: '',
      companyId: '',
      roleList: []
    };
  },
  mounted: function() {
    if (localStorage.getItem("goodlist")) {
      let goodlist = localStorage.getItem("goodlist");
      this.recomId = JSON.parse(goodlist).recomId;
    }
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
      this.isAll = this.$route.query.recomId;
    }else{
      this.recom_id = this.recomId;
      this.isAll = '';
    }
    if(this.$route.query.companyId){
      this.companyId = this.$route.query.companyId;
    }
    this.initdata();
    this.isHongKong();
    this.initBank();
    this.initProvinces();
    this.selectLoginRoles()
  },
  methods: {
    selectLoginRoles () {
      this.roleList = []
      let that = this;
      const options = {
        url: "/user/roles/selectLoginRoles",
        method: "post",
        data: {}
      };
      axios(options)
        .then((response) => {
          if (response.data.code === 200) {
            that.roleList = response.data.data
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    },
    // 判断是否为香港用户
    isHongKong(){
      let that = this;
      const options = {
        url: "distribution/distribution/isHongKong",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: this.recom_id
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            if(response.data.data == true){
              that.is_HongKong = true;
              that.is_HongKongCheck = true;
            }else{
              that.is_HongKong = false;
              that.is_HongKongCheck = false;
            }
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    handleClose() {
      let c = document.getElementById("myCanvas");
      let cxt = c.getContext("2d");
      cxt.clearRect(0, 275, 300, 55);
      this.outerVisibles = false;
    },
    initBank() {
      let that = this;
      const options = {
        url: "distribution/B2cBankInfoController/getBankInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.bankList = response.data.data;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    initProvinces() {
      let that = this;
      const options = {
        url: "distribution/B2cRegionalLinkageController/queryAllProvince",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.ProvincesList = response.data.data;
          } else {
             http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    bankChange(val) {
      let that = this;
      if(val == ''){
        that.cityList = '';
        that.ruleForm.bankCity = "";
      }else{
        const options = {
          url: "distribution/B2cRegionalLinkageController/queryCity",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            provinceName: val
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.cityList = response.data.data;
              if(that.ruleForm.bankCity){
                that.ruleForm.bankCity = "";
              }
            } else {
              http.handleEorrorCode(response,that);
            }
          })
          .catch(error => {
            http.handleHttpError(error, that);
          });
      }
    },
    queryCity(val) {
      let that = this;
      const options = {
        url: "distribution/B2cRegionalLinkageController/queryCity",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          provinceName: val
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.cityList = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    CodeClick(row) {
      this.CurrentSelection = row;
      this.outerVisibles = true;
      let that = this;
      const options = {
        url: "distribution/distribution/getShoperQRCode",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          shoperIvcode: that.CurrentSelection.shoperIvcode,
          recomId: that.CurrentSelection.recomId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.qrcodeParams.url = response.data.data.domainUrl;
            let cav = document.getElementById("qrcode");
            let strDataURI = cav.firstChild.toDataURL("image/png");
            that.aaaClick(row);
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    aaaClick(row) {
      this.CurrentSelection = row;
      let that = this;
      const options = {
        url: "distribution/distribution/getShoperQRCode",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          shoperIvcode: that.CurrentSelection.shoperIvcode,
          recomId: that.CurrentSelection.recomId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.qrcodeParams.url = response.data.data.domainUrl;
            let c = document.getElementById("myCanvas");
            let cxt = c.getContext("2d");
            let cav = document.getElementById("qrcode");
            let strDataURI = cav.firstChild.toDataURL("image/png");
            let scream = document.getElementById("scream");
            that.imgurl = strDataURI;
            scream.onload = function() {
              cxt.drawImage(scream, 25, 25);
              cxt.font = "16px microsoft yahei";
              if (
                that.CurrentSelection.shooperName !== null &&
                that.CurrentSelection.shooperName.length < 29
              ) {
                that.MarginLeft =
                  (300 - Number(that.CurrentSelection.shooperName.length) * 12) /
                  2;
                cxt.fillText(
                  that.CurrentSelection.shooperName.substring(0, 28),
                  that.MarginLeft,
                  300
                );
              }
              let logoimg = document.querySelector(".logoimg");
              cxt.drawImage(logoimg,125,125,50,50);
            }
            var imageData = cxt.getImageData(0, 0, c.width, c.height);
            for(var i = 0; i < imageData.data.length; i += 4) {
              // 当该像素是透明的,则设置成白色
              if(imageData.data[i + 3] == 0) {
                imageData.data[i] = 255;
                imageData.data[i + 1] = 255;
                imageData.data[i + 2] = 255;
                imageData.data[i + 3] = 255;
              }
            }
            cxt.putImageData(imageData, 0, 0);

            cav.lastChild.style.display = 'none';
            document.querySelector(".logoimg").style.display = 'none';
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    EditClick(row) {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      let Object = { ...JSON.parse(row.payAccountInfos), ...row };
      this.ruleForm = MethodsBus.cloneRow(Object);
      if(row.payAccountInfos && JSON.parse(row.payAccountInfos).bankName){
        this.$set(this.ruleForm, 'bankName', JSON.parse(row.payAccountInfos).bankName)
      }else{
        this.$set(this.ruleForm, 'bankName', undefined)
      }
      if(this.ruleForm.bankProvince){
        this.queryCity(this.ruleForm.bankProvince);
      }
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.OuterWidth = "800px";
      this.EditDialog = 1;
      console.log(this.ruleForm)
      if (this.ruleForm.shoperRole === 3) {
        this.RoleList = [{ value: 1, label: "员工" }, { value: 2, label: "店长" }, { value: 3, label: "老板" }]
      } else {
        this.RoleList = [{ value: 1, label: "员工" }, { value: 2, label: "店长" }]
      }
      if(this.is_HongKongCheck == true){
        this.is_HongKong = true;
      }else{
        this.is_HongKong = false;
      }
    },
    DetailClick(row) {
      this.$router.push({ path: "/selesdetail" , query:{ recomId: this.recom_id, companyId: this.companyId}});
      localStorage.setItem(
        "goodlist",
        JSON.stringify({
          shoperId: row.shoperId,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
          shopId: this.shopId
        })
      );
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.OuterWidth = "500px";
      this.CurrentSelection = item;
    },
    AddClick() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm = {};
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.OuterWidth = "800px";
      this.EditDialog = 1;
      this.is_HongKong = false;
      this.RoleList = [{ value: 1, label: "员工" }, { value: 2, label: "店长" }]
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    Goback() {
      if(this.isAll == ''){
        this.$router.push({ name: "StoreList", params: { pageNo : this.pageNo , pagesize:this.pageSize}});
      }else{
        this.$router.push({ name: "StoreList", query: {recomId: this.recom_id, companyId: this.companyId, recomName: this.$route.query.recomName},params: { pageNo : this.pageNo , pagesize:this.pageSize}});
      }
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            let shooperName = '';
            let trueName = '';
            if(this.ruleForm.shooperName){
              shooperName = this.ruleForm.shooperName.replace(/\s+/g,'');
            }else{
              shooperName = this.ruleForm.shooperName;
            }
            if(this.ruleForm.trueName){
              trueName = this.ruleForm.trueName.replace(/\s+/g,'');
            }else{
              trueName = this.ruleForm.trueName;
            }
            const options = {
              url: "distribution/distribution/updateB2cO2oShoper",
              method: "post",
              headers: { "Content-Type": "application/json" },
              data: {
                companyId: that.companyId,
                shoperId: that.ruleForm.shoperId,
                shooperName: shooperName,
                shooperTel: that.ruleForm.shooperTel,
                shoperRole: that.ruleForm.shoperRole,
                shopId: that.shopId,
                b2cPayAccountInfoVOS: [
                  {
                    bankType: 'P',
                    trueName: trueName,
                    bankCard: that.ruleForm.bankCard,
                    bankName: that.ruleForm.bankName,
                    bankBranchName: that.ruleForm.bankBranchName,
                    bankProvince: that.ruleForm.bankProvince,
                    bankCity: that.ruleForm.bankCity,
                    idCard: that.ruleForm.idCard,
                    bankTel: that.ruleForm.bankTel
                  }
                ]
              }
            };
            axios(options).then(function(response) {
              that.outerVisible = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
              } else {
                 http.handleEorrorCode(response,that);
              }
            });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            let shooperName = '';
            let trueName = '';
            if(this.ruleForm.shooperName){
              shooperName = this.ruleForm.shooperName.replace(/\s+/g,'');
            }else{
              shooperName = this.ruleForm.shooperName;
            }
            if(this.ruleForm.trueName){
              trueName = this.ruleForm.trueName.replace(/\s+/g,'');
            }else{
              trueName = this.ruleForm.trueName;
            }
            const options = {
              url: "distribution/distribution/addB2cO2oShoper",
              method: "post",
              headers: { "Content-Type": "application/json" },
              data: {
                companyId: that.companyId,
                shooperName: shooperName,
                shooperTel: that.ruleForm.shooperTel,
                shoperRole: that.ruleForm.shoperRole,
                shopId: that.shopId,
                recomId: that.recom_id,
                b2cPayAccountInfoVOS: [
                  {
                    bankType: 'P',
                    trueName: trueName,
                    bankCard: that.ruleForm.bankCard,
                    bankName: that.ruleForm.bankName,
                    bankBranchName: that.ruleForm.bankBranchName,
                    bankProvince: that.ruleForm.bankProvince,
                    bankCity: that.ruleForm.bankCity,
                    idCard: that.ruleForm.idCard,
                    bankTel: that.ruleForm.bankTel
                  }
                ]
              }
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                    http.handleEorrorCode(response,that);
                }
              })
              .catch(error => {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    MakeSure() {
      let that = this;
      this.disabled = true;
      const options = {
        url: "distribution/distribution/deleteB2cO2oShoper",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          shoperId: that.CurrentSelection.shoperId,
        })
      };
      axios(options)
        .then(function(response) {
          that.disabled = false;
          that.outerVisible = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          that.disabled = false;
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      if (localStorage.getItem("goodlist")) {
        let goodlist = localStorage.getItem("goodlist");
        this.shopId = JSON.parse(goodlist).shopId;
        this.recomId = JSON.parse(goodlist).recomId;
        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
      }
      const options = {
        url: "distribution/distribution/selectB2cO2oshoper",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          shopId: JSON.parse(localStorage.getItem("goodlist")).shopId,
          recomId: that.recom_id
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            response.data.data.forEach(element => {
              if(element.shoperRole === 1){
                element.shoperrole = '员工'
              }else if(element.shoperRole === 2){
                element.shoperrole = '店长'
              }else if(element.shoperRole === 3){
                element.shoperrole = '老板'
              }
            });
            that.UserManagementList = response.data.data;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.TitleStyle {
  color: #6a7786;
}
.InputWidth {
  width: 202px;
}
.ModelPaddings {
  margin-top: -20px;
}
#qrCode-canvas {
  width: 200px !important;
  height: 200px !important;
}
.qrcode img {
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreManage/SelesClerkList.vue